import styled from 'styled-components';
import colors from 'styles/colors';

import { FullWidthTableContent as GlobalTableContent } from 'styles/table';

/* eslint-disable import/prefer-default-export */
export const FullWidthTableContent = styled(GlobalTableContent)`
  border: 1px solid ${colors.tableBorder};
  color: ${colors.tableText};
  font-size: 12px;
  margin-bottom: 2em;
`;
